import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import SendAMessage from "./sections/SendAMessage";
import DoveTrovarci from "./sections/DoveTrovarci";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <SendAMessage />
      <DoveTrovarci />
      <Footer />
    </div>;
}